import { HELP_URL, LEGAL_URL } from '@/constants/urls';

export const FREQUENTLY_ASKED_QUESTIONS: {
  title: string;
  description: React.ReactNode;
}[] = [
  {
    title: 'What is a data broker?',
    description: (
      <p className="dboo-faq__item-text">
        A data broker is a company or individual that gathers personal
        information about people from various sources, like online activities,
        public records, and purchases. They then compile this data and sell it
        to businesses for marketing, research, and other uses. This information
        can include your contact information such as name, address, phone
        number, and email address. It could also include your location data,
        online browsing history, social media activity, demographic details,
        education and professional information, and financial information.
      </p>
    ),
  },
  {
    title: 'Why should I opt out of data brokers?',
    description: (
      <>
        <p className="dboo-faq__item-text">
          Opting out of data brokers is important for several reasons:
        </p>
        <ul className="dboo-faq__item-list">
          <li>
            <strong className="dboo-faq__item-text--strong">
              Protect Your Privacy:
            </strong>{' '}
            Data brokers collect and sell detailed personal information,
            including your habits, preferences, and location. Opting out limits
            how much of your private life is accessible to companies.
          </li>
          <li>
            <strong className="dboo-faq__item-text--strong">
              Reduce Spam and Unwanted Ads:
            </strong>{' '}
            By limiting the amount of information available about you, opting
            out can decrease the number of unsolicited marketing emails, phone
            calls, and ads you receive.
          </li>
          <li>
            <strong className="dboo-faq__item-text--strong">
              Lower Risk of Identity Theft:
            </strong>{' '}
            Less available personal information means a lower chance of it
            falling into the wrong hands, helping to protect you from identity
            theft and fraud.
          </li>
          <li>
            <strong className="dboo-faq__item-text--strong">
              Increase Control Over Your Data:
            </strong>{' '}
            Opting out gives you more say in who can access and use your
            personal information, ensuring it&apos;s only shared with your
            consent.
          </li>
          <li>
            <strong className="dboo-faq__item-text--strong">
              Prevent Misuse of Information:
            </strong>{' '}
            Data brokers may not always handle your information responsibly. By
            opting out, you reduce the risk of your data being used in ways you
            don’t approve of or that could harm you.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: 'How does Aura help remove my personal information online?',
    description: (
      <ul className="dboo-faq__item-list dboo-faq__item-list--decimal">
        <li>
          Aura scans data broker websites to find profiles that contain your
          information that was collected and created without your permission.
        </li>
        <li>
          Aura then sends requests to the data brokers to remove your
          information. This is done automatically and we update you on the
          progress along the way.
        </li>
        <li>
          Aura ensures ongoing protection by continuously monitoring the data
          broker websites and sending removal requests to help prevent brokers
          from recollecting your data in the future.
        </li>
      </ul>
    ),
  },
  {
    title: 'What is the Dark Web?',
    description: (
      <>
        <p className="dboo-faq__item-text">
          The Dark Web is a collection of websites, forums, and marketplaces
          that are only accessible by using the Tor browser. This specialized
          browser grants users a level of anonymity that is especially appealing
          to cybercriminals and hackers.
        </p>
        <p className="dboo-faq__item-text">
          If your information is on the dark web (i.e., through a data broker
          data breach), criminals could commit identity theft, open credit
          accounts, take out loans, or make purchases in your name, leading to
          financial loss and credit damage.
        </p>
        <p className="dboo-faq__item-text">
          Aura scans and monitors the Dark Web and alerts you if your SSN or
          personal info is found on the Dark Web, and offers recommendations for
          protection.
        </p>
      </>
    ),
  },
  {
    title: 'Who owns Aura?',
    description: (
      <>
        <p className="dboo-faq__item-text">
          Aura, headquartered in Boston, Massachusetts, was established in 2014
          by Hari Ravichandran following his experience with identity theft. In
          July 2019, Intersections Inc. and iSubscribed combined its services
          and renamed itself to Aura. As a result, their respective brands
          Intrusta and Identity Guard were also brought together.
        </p>
        <p className="dboo-faq__item-text">
          Aura (and Aura.com) should not be confused with Aura International, a
          training and management consulting firm based in Beijing, China.
        </p>
      </>
    ),
  },
  {
    title: 'Is my data safe with Aura?',
    description: (
      <p className="dboo-faq__item-text">
        Aura does not sell customer data as described in our privacy policy (
        <a
          className="dboo-faq__item-link"
          href={LEGAL_URL}
          rel="noreferrer"
          target="_blank"
        >
          link
        </a>
        ). Aura does not operate any data broker or people data mining websites.
      </p>
    ),
  },
  {
    title: 'Where is your customer support based?',
    description: (
      <>
        <p className="dboo-faq__item-text">
          Aura offers 24/7 support based in the U.S.
        </p>
        <p className="dboo-faq__item-text">
          You can get in touch with our customer support team directly by
          visiting{' '}
          <a
            className="dboo-faq__item-link"
            href={HELP_URL}
            rel="noreferrer"
            target="_blank"
          >
            {HELP_URL}
          </a>
          .
        </p>
      </>
    ),
  },
];
